import { StepProgress, type Step } from '@/shared/ui/primitives';

import type { RxWizardStepId } from '../model/types';

const RX_WIZARD_STEPS: Array<Step<RxWizardStepId>> = [
  { id: 'details', label: 'Rx Details' },
  { id: 'review', label: 'Review' },
  { id: 'confirmation', label: 'Confirmation' },
];

export interface RxWizardProgressProps {
  stepId: RxWizardStepId;
}

export function RxWizardProgress({ stepId }: RxWizardProgressProps) {
  return (
    <StepProgress
      steps={RX_WIZARD_STEPS}
      currentStepId={stepId}
      showLabels={false}
      easing="easeOutQuad"
    />
  );
}
